class Policy {
    constructor() {
        this.name = '';
        this.description = '';
        this.intervalInMinutes = 7 * 24 * 60;
    }

    toRaw() {
        const clone = _.clone(this);

        clone.uuid = undefined;
        clone.vmsCount = undefined;
        clone.compliancyStatus = undefined;
        clone.uncompliantVirtualMachineCount = undefined;
        clone.compliantVirtualMachineCount = undefined;

        return clone;
    }

    static fromRaw(raw) {
        const res = new Policy();

        res.uuid = raw.uuid;
        res.name = raw.name;
        res.description = raw.description;
        res.intervalInMinutes = raw.intervalInMinutes;
        res.backupWindow = raw.backupWindow;
        res.backupTarget = raw.backupTarget;
        res.backupTargetType = raw.backupTargetType;
        res.snapshotLocation = raw.snapshotLocation;
        res.isDefault = raw.isDefault;
        res.backupRetention = raw.backupRetention;
        res.copyRetention = raw.copyRetention;
        res.copyTarget = raw.copyTarget;
        res.vmsCount = raw.virtualMachinesCount;
        res.compliancyStatus = raw.compliancy;
        res.uncompliantVirtualMachineCount = raw.unCompliantVirtualMachinesCount;
        res.compliantVirtualMachineCount = raw.compliantVirtualMachinesCount;
        res.readOnly = raw.isReadOnly;
        res.tier = raw.tier;
        res.estimatedConsumptionInBytes = raw.estimatedConsumptionInBytes;
        res.archive = raw.archive;
        res.tags = raw.tags;

        return res;
    }

    static getSearchKey() {
        return 'name';
    }

    static getCompliancyKey() {
        return 'compliancy';
    }

    static getCompliancyOptions() {
        return [
            { label: 'Success', value: 'GREEN' },
            { label: 'Failure', value: 'RED' },
            { label: 'Undefined', value: 'GREY' }
        ];
    }
}

module.exports = Policy;



// WEBPACK FOOTER //
// ./src/azurebackup/model/Policy.js